// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__y3nvl","toggle":"styles_toggle__3DVRx","preview":"styles_preview__2DACs"};